@if (isActive()) {
	<div class="representation-banner" role="status" aria-live="polite" aria-atomic="true">
		<div></div>
		<div class="banner-text">
			<mat-icon fontIcon="groups" aria-hidden="true"></mat-icon>
			@if (label()) {
				<span>{{ 'representation.active' | transloco }} {{ label() }}</span>
			} @else {
				<span>{{ 'representation.active' | transloco }}</span>
			}
		</div>

		<lvr-button
			variant="primary"
			icon="close"
			[label]="'representation.end' | transloco"
			[attr.aria-label]="'representation.end' | transloco"
			(click)="endRepresentation()"
		>
		</lvr-button>
	</div>
}
